import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const Dashboard = styled.div`
	display: grid;
	gap: 24px;
	margin-bottom: 32px;
	grid-template-columns: repeat(3, 1fr);

	  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); /* 2 por linha em tablets */
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr; /* 1 por linha em mobile */
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  padding: 16px 0;

  &::after {
    content: '';
    left: 0;
    bottom: -17px; /* 👈 “desce” o border */
    width: 100%;
    height: 1px;
    background-color: #ccc;
	position:relative;
  }

`;

export const TableContainer = styled.div`
	width: 100%;
	padding: 30px;
	border-radius: 12px;
	background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const ActionsContainer = styled.div`
	display: flex;
	gap: 4px;
`;

export const BestOfferContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	& button {
		all: unset;
		color: ${({ theme }) => theme.colors.primary.medium};
		cursor: pointer;
	}
`;

export const TableWrapper = styled.div`
	overflow-x: auto;
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FullLine = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const HalfLine = styled.div``;

export const Form = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(2, 1fr);

		${FullLine} {
			grid-column: 1 / -1;
		}

		${HalfLine} {
			grid-column: span 1;
		}
	}
`;

export const NoData = styled.div`
	text-align: center;
	padding: 50px;
`;


export const ClickableSpan = styled.span`
    cursor: pointer;
    &:hover {
        color: blue;
        text-decoration: underline;
    }
`;


export const UserInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const UserInfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #e0e0e0;
`;

export const UserInfoLabel = styled.span`
    font-weight: bold;
	position: relative;
	right: 10px;
`;

export const UserInfoValue = styled.span`
    color: #555;
	word-break: break-word;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  h1 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111;
    margin: 0;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;

  a {
    text-decoration: none;
  }

  button {
    background-color: #e9620f;
    color: white;
    font-weight: 500;

    &:hover {
      background-color: #cc550d;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  width: 700px;

  form {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  	width: 100%;

  }
`;
